module.exports = __webpack_public_path__ + "static/media/group.f8660569.png";